import { render, staticRenderFns } from "./hqglLogisticsTransferDetail.vue?vue&type=template&id=2b7a831f&scoped=true&"
import script from "./hqglLogisticsTransferDetail.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsTransferDetail.vue?vue&type=script&lang=js&"
import style0 from "./hqglLogisticsTransferDetail.vue?vue&type=style&index=0&id=2b7a831f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a831f",
  null
  
)

export default component.exports